import React, { useCallback, useEffect, useState } from "react";
import {
    Box,
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Menu,
    MenuItem,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PrintIcon from "@mui/icons-material/Print";
import { DataGrid } from "@mui/x-data-grid";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import "../../FrontOffice/OutPatients/OutpatientHome.css"

import {
    AppointmentCard,
    CommonPatientDetails,
} from "../../../Components/Common Components/CommonComponents";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import Loader from "../../../Components/Loader";
import { Colors } from "../../../Styles/Colors";
import { AmountFormat, ContentInTooltip, formatDate } from "../../../Components/CommonFunctions/CommonFunctions";
import { ImagePaths } from "../../../Utility/ImagePaths";
import { renderIconButton } from "../../Doctor/DoctorNotes/Common/DocCommonComponent";
import PaymentsIcon from '@mui/icons-material/Payments';
import ReportIcon from '@mui/icons-material/Report';
import CollectAdvanceModal from "../../Ayurveda/Counsellor/CounsellorAdvanceCollect";
import { getCachevalue, localGetItem, setCachevalue } from "../../../Utility/Services/CacheProviderService";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";


const WalkInAdmission = (props) => {
    // paging & UI
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    // data
    const [appointments, setAppointments] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [statusCount, setStatusCount] = useState({});
    const [menuRow, setMenuRow] = useState(null);
    const [billMenuAnchor, setBillMenuAnchor] = useState(null);
    const [billMenuRow, setBillMenuRow] = useState(null);
    const [printLoading, setPrintLoading] = useState(false);
    const [openAdvance, setOpenAdvance] = useState(false);
    const [finalBillDialogOpen, setFinalBillDialogOpen] = useState(false);
    const [finalBillDialogRow, setFinalBillDialogRow] = useState(null);
    const [checkoutDialogOpen, setCheckoutDialogOpen] = useState(false);
    const [checkoutDialogRow, setCheckoutDialogRow] = useState(null);
    const [finalBillApiLoading, setFinalBillApiLoading] = useState(false);

    // filters / controls
    const [filterDate, setFilterDate] = useState(new Date());
    const [selectedStatus, setSelectedStatus] = useState("Inprogress");
    const [searchKey, setSearchKey] = useState("");
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [selectedOption, setSelectedOption] = useState('');
    const history = useHistory();
    let LoggedData = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo")) : null
    const pageSizeOptions = [10, 20, 30];


    const statusColorMap = {
        Pending: { bg: "#fef4e0ff", color: "#b0812fff" },
        Scheduled: { bg: "#D8E6FF", color: "#034AA6" },
        Inprogress: { bg: "#e3f6fbff", color: "#41aeccff" },
        Cancelled: { bg: "#ffececff", color: "#c44242ff" },
        Completed: { bg: "#e4fde8ff", color: "#39de5fff" }
    };

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
        setIsLoading(false)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
        setIsLoading(false)
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    // Fetch appointments using AYURVEDA_COUNSELLOR endpoint
    const fetchAppointments = useCallback(() => {
        setIsLoading(true);
        try {
            let dateKey = filterDate
                ? dayjs(filterDate).format("YYYY-MM-DD")
                : "";
            const qs = `?status=${selectedStatus || ""}&date=${dateKey}&doctor_filter=&search=${encodeURIComponent(
                searchKey || ""
            )}`;
            RestAPIService.getAll(Serviceurls.AYURVEDA_COUNSELLOR_WALKIN + qs)
                .then((res) => {
                    if (res.data.status === "success") {
                        // convert rows and add temp_start_date for datepicker
                        const list = (res.data.data || []).map((row, idx) => ({
                            ...row,
                            sno: idx + 1,
                        }));
                        setAppointments(list);
                        setStatusCount(res.data || {});
                    } else {
                        errorMessage(res.data.message || "Failed to fetch appointments");
                    }
                })
                .catch((e) => errorMessage(e?.response?.data?.message || e.message))
                .finally(() => setIsLoading(false));
        } catch (e) {
            setIsLoading(false);
            errorMessage(e.message);
        }
    }, [filterDate, selectedStatus]);

    useEffect(() => {
        fetchAppointments();
    }, [fetchAppointments]);

    // Update API (cancel / reschedule) using updateWithOutId pattern

    const confirmCancel = () => {
        if (!selectedToCancel) {
            setCancelDialogOpen(false);
            return;
        }
        const payload = {
            status: "Cancelled",
            appointment_id: selectedToCancel?.id,
        };
        updateAppointment(payload);
        setCancelDialogOpen(false);
    };

    // top card click
    const onCardClick = (statusKey) => {
        setSelectedStatus(statusKey);
    };

    const PaymentStatus = (orderAmount , advanceAmount, BalanceDetails = {}) => {
        const balAmount = orderAmount - advanceAmount;
        const renderPayment = (Icon, label, amount, color, onClick) => {
            return (
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={onClick}>
                    <Icon sx={{ fontSize: "0.9vw", marginRight: '0.4vw', color: color }} />
                    <Typography color={color} fontSize={"0.8vw"}>{`${label} : ${AmountFormat(amount)} `}</Typography>
                </Box>
            )
        }
        return (
            <Box>
                {renderPayment(PaymentsIcon, 'Order', orderAmount, '#616161')}
                {renderPayment(CheckCircleIcon, 'Advance', advanceAmount, 'green')}
                {renderPayment(ReportIcon, 'Balance', balAmount, '#B8170D')}
            </Box>
        )
    }

    const onApproveClick = (row) => {
        setOpenAdvance(true);
        setMenuRow(row)
    };

    const openBillPrint = (url) => {
        setPrintLoading(true);
        RestAPIService.getAll(url)
            .then((response) => {
                const file = new Blob([response.data], { type: "application/pdf" });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            })
            .catch((e) => {
                errorMessage(e?.response?.data?.message || e?.message || "Print failed");
            })
            .finally(() => {
                setPrintLoading(false);
                setBillMenuAnchor(null);
                setBillMenuRow(null);
            });
    };

    const handleApproxBillPrint = (row) => {
        const admissionId = row?.id ?? null;
        openBillPrint(Serviceurls.AYURVEDA_WALKIN_APPROX_BILL_PRINT + `?walkin_admission_id=${admissionId}`);
    };
    const handleDetailBillPrint = (row) => {
        const admissionId = row?.id ?? null;
        openBillPrint(Serviceurls.AYURVEDA_WALKIN_DETAILED_BILL_PRINT + `?walkin_admission_id=${admissionId}&preview=`);
    };
    const handleSummaryBillPrint = (row) => {
        const admissionId = row?.id ?? null;
        openBillPrint(Serviceurls.AYURVEDA_WALKIN_SUMMARY_BILL_PRINT + `?walkin_admission_id=${admissionId}`);
    };

    const handleCommonBarcodePrint = (row) => {
        const patientId = row?.patient_id ?? null;
        const walkinAdmissionId = row?.id ?? null;
        openBillPrint(Serviceurls.COMMON_BARCODE_PRINT + `?patient_id=${patientId}&walkin_admission_id=${walkinAdmissionId}&export_type=pdf`);
    };

    const handleTablePrint = () => {
        const dateKey = filterDate ? dayjs(filterDate).format("YYYY-MM-DD") : "";
        const qs = `?status=${selectedStatus || ""}&date=${dateKey}&doctor_filter=&search=${encodeURIComponent(searchKey || "")}&export_type=pdf`;
        setPrintLoading(true);
        RestAPIService.getAll(Serviceurls.AYURVEDA_COUNSELLOR_WALKIN + qs)
            .then((response) => {
                const file = new Blob([response.data], { type: "application/pdf" });
                window.open(URL.createObjectURL(file));
            })
            .catch((e) => errorMessage(e?.response?.data?.message || e?.message || "Print failed"))
            .finally(() => setPrintLoading(false));
    };

    const renderStatusChip = (status) => {
        const clr = statusColorMap[status] || { bg: "#E0E0E0", color: "#424242" };
        return (
            <Chip
                label={status}
                size="small"
                sx={{
                    backgroundColor: clr.bg,
                    border: `1px solid ${clr.color}`,
                    px: 1,
                    py: 0.4,
                    borderRadius: "3px",
                    color: clr.color,
                    width: "90%",
                    height: "5dvh",
                    textAlign: "center",
                }}
            />
        );
    };

    const renderTreatmentChip = (statusObj) => {
        if (!statusObj) return null;

        const { status, subText } = statusObj;

        let color = "#000";

        switch (status) {
            case "Treatment Pending":
                color = "#d32f2f"; // red
                break;

            case "Assign Treatment":
                color = "#d32f2f"; // red
                break;

            case "All Slots Scheduled":
                color = "#2e7d32"; // green
                break;

            case "Partially Scheduled":
                color = "#1976d2"; // blue
                break;

            default:
                color = "#000";
        }

        return (
            <Box sx={{ lineHeight: 1.2 }}>
                <Typography
                    sx={{
                        fontSize: "0.85rem",
                        fontWeight: 700,
                        color: color,
                    }}
                >
                    {status || "-"}
                </Typography>

                {subText && (
                    <Typography
                        sx={{
                            fontSize: "0.7rem",
                            fontWeight: 500,
                            color: color,
                            opacity: 0.85,
                        }}
                    >
                        {subText}
                    </Typography>
                )}
            </Box>
        );
    };

    // Final bill API (initiate or checkout) - like IP Home
    const callFinalBillGen = useCallback((row, status) => {
        if (!row?.id) return;
        setFinalBillApiLoading(true);
        const payload = { walkin_admission_id: row.id, status };
        RestAPIService.create(payload, Serviceurls.AYURVEDA_WALKIN_FINAL_BILL_GEN)
            .then((res) => {
                if (res.data?.status === "success") {
                    successMessage(res.data?.message || (status === "Checked Out" ? "Checked out successfully" : "Final bill initiated"));
                    fetchAppointments();
                    setFinalBillDialogOpen(false);
                    setFinalBillDialogRow(null);
                    setCheckoutDialogOpen(false);
                    setCheckoutDialogRow(null);
                    if (status === "Initiate Bill") {
                        const patientDetails = {
                            ...row,
                            ...(res.data?.data || row),
                            module_type: "Walkin",
                        };
                        setCachevalue(JSON.stringify(patientDetails), "IppatientData");
                        history.push({ pathname: "/WalkInFinalSettlement", state: { Patient_details: patientDetails } });
                    }
                } else {
                    errorMessage(res.data?.message || "Request failed");
                }
            })
            .catch((e) => errorMessage(e?.response?.data?.message || e?.message || "Request failed"))
            .finally(() => setFinalBillApiLoading(false));
    }, [fetchAppointments]);

    const handleFinalBillClick = useCallback((row) => {
        const treatmentCompleted = row?.treatment_status?.status === "Completed" || row?.treatment_status === "Completed";
        if (!treatmentCompleted && !row?.is_final_bill_initiated) return;
        if (row?.status === "Cancelled" || row?.status === "Completed") return;
        if (!row?.is_final_bill_initiated) {
            setFinalBillDialogRow(row);
            setFinalBillDialogOpen(true);
        } else if (!row?.is_final_bill_generated) {
            const patientDetails = { ...row, module_type: "Walkin" };
            setCachevalue(JSON.stringify(patientDetails), "IppatientData");
            history.push({ pathname: "/WalkInFinalSettlement", state: { Patient_details: patientDetails } });
        } else {
            setCheckoutDialogRow(row);
            setCheckoutDialogOpen(true);
        }
    }, [history]);

    const onInitiateFinalBillConfirm = () => {
        if (finalBillDialogRow) callFinalBillGen(finalBillDialogRow, "Initiate Bill");
    };

    const onCheckoutConfirm = () => {
        if (checkoutDialogRow) callFinalBillGen(checkoutDialogRow, "Checked Out");
    };

    // columns (centered headers, widths tuned to screenshot)
    const columns = [
        {
            field: "patient_details",
            headerName: "Patient's Details",
            flex: 0.25,
            renderCell: (params) => (
                <Box>
                    <CommonPatientDetails data={params.row} />
                </Box>
            ),
            headerAlign: "left",
            align: "left",
        },
        {
            field: "referred_doctor",
            headerName: "Cosultant Doctor",
            flex: 0.2,
            renderCell: (params) => (
                <Typography sx={{ fontSize: "0.9vw" }}>
                    {params.row?.doctor_name || "-"}
                </Typography>
            ),
            headerAlign: "left",
            align: "left",
        },
        {
            field: "completed_days",
            headerName: "Days Completed",
            flex: 0.150,
            renderCell: (params) => (
                <Typography sx={{ fontSize: "0.9vw" }}>
                    {(params.row?.completed_days ?? "-") + " / " + params.row?.no_of_days || "-"}
                </Typography>
            ),
            headerAlign: "left",
            align: "left",
        },
        {
            field: "completed_appointment",
            headerName: "Completed Appointment",
            flex: 0.20,
            renderCell: (params) => (
                <Typography sx={{ fontSize: "0.9vw" }}>
                    {(params.row?.completed_appointment ?? "-")}
                </Typography>
            ),
            headerAlign: "left",
            align: "left",
        },
        {
            field: 'bill_amount', headerName: 'PaymentStatus',
            headerClassName: 'eMed_Apt_TblHead',
            flex: 0.25, density: 'compact',
            headerAlign: "left", align: "left",
            renderCell: (params) => (
                <div>{PaymentStatus(params.row?.order_amount ? params.row?.order_amount : 0, params.row?.total_advance_amount ? params.row?.total_advance_amount : 0)}</div>)
        },
        {
            field: "treatment_status",
            headerName: "Treatment Status",
            flex: 0.15,
            renderCell: ({ row }) => renderTreatmentChip(row.treatment_status)
        },
        {
            field: "status",
            headerName: "Status",
            flex: 0.15,
            renderCell: ({ row }) => renderStatusChip(row.status)
        },
        {
            field: "action",
            headerName: "Action",
            flex: 0.15,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                {
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'row'}}>
                            <Tooltip title={"Order"} placement='top' arrow>
                            <div>
                                <IconButton size="small" disabled={(params.row.status === "Cancelled" || params?.row?.is_final_bill_generated || params?.row?.is_final_bill_initiated) ? true : false} onClick={() => { handleOrderClick(params) }}><img className='eMed_IP_AptTbl_Status_Icon' src={(params.row.status === "Cancelled" || params?.row?.is_final_bill_generated || params?.row?.is_final_bill_initiated) ? ImagePaths.DisabledCreateBill.default : ImagePaths.BillCreated.default} alt='ServiceBill' /></IconButton>
                            </div>
                            </Tooltip>
                            <Tooltip title={params.row.status === "Completed" ? 'Checked out' : params.row.discharge_status === "Checked Out" ? 'Check out' : params.row.is_final_bill_generated ? 'Checkout' : (params.row.is_final_bill_initiated ) ? 'Generate Final Bill' : 'Initiate Final Bill'} placement='top' arrow>
                                <div>
                                    <IconButton
                                        size="small"
                                        disabled={(params.row.status === "Cancelled" || params.row.status === "Completed") || (!params.row?.is_final_bill_initiated && (params.row?.treatment_status?.status !== "Completed" && params.row?.treatment_status !== "Completed")) ? true : false}
                                        onClick={() => handleFinalBillClick(params.row)}
                                        sx={params.row?.is_final_bill_generated ? { filter: "none" } : {}}
                                    >
                                        <img className='eMed_IP_AptTbl_Status_Icon' src={params.row.status === "Cancelled" || params.row.status === "Completed" ? ImagePaths.FrontOfficeOff.default : (params.row?.discharge_status === "Checked Out" ? ImagePaths.PatientCheckOut.default : params.row.is_final_bill_generated ? ImagePaths.PatientCheckOut.default : params.row.is_final_bill_initiated ? ImagePaths.ipBillAction.default : ImagePaths.IpCheckoutOn.default)} alt='Checkout' />
                                    </IconButton>
                                </div>
                            </Tooltip>
                            { LoggedData?.module_name === "front_office" && (
                            <Tooltip title="More" placement="top" arrow>
                                <IconButton
                                    size="small"
                                    disabled={params.row.status === "Cancelled"}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setBillMenuAnchor(e.currentTarget);
                                        setBillMenuRow(params.row);
                                    }}
                                        >
                                            <MoreVertIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            <Menu
                                anchorEl={billMenuAnchor}
                                open={Boolean(billMenuAnchor)}
                                onClose={() => { setBillMenuAnchor(null); setBillMenuRow(null); }}
                                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                sx={{ boxShadow: "0px 1px 7px -3px #a9a9a9" }}
                                // transformOrigin={{ vertical: "top", horizontal: "right" }}
                            >
                                <MenuItem disabled={params.row.status === "Cancelled" || params.row.status === "Completed"} onClick={() => { const row = billMenuRow; setBillMenuAnchor(null); setBillMenuRow(null); if (row) handleApproxBillPrint(row); }}>Approximate Bill</MenuItem>
                                <MenuItem disabled={!params.row.is_final_bill_generated || !params.row.is_final_bill_initiated} onClick={() => { const row = billMenuRow; setBillMenuAnchor(null); setBillMenuRow(null); if (row) handleDetailBillPrint(row); }}>Detail Bill Print</MenuItem>
                                <MenuItem disabled={!params.row.is_final_bill_generated || !params.row.is_final_bill_initiated} onClick={() => { const row = billMenuRow; setBillMenuAnchor(null); setBillMenuRow(null); if (row) handleSummaryBillPrint(row); }}>Summary Bill Print</MenuItem>
                                <MenuItem onClick={() => { const row = billMenuRow; setBillMenuAnchor(null); setBillMenuRow(null); if (row) handleCommonBarcodePrint(row); }}>Common Barcode</MenuItem>
                            </Menu>
                        </Box>
                        // renderIconButton(
                        //     "Recieve Payment",
                        //     ImagePaths.ReceivePayment.default,
                        //     () => {
                        //         onApproveClick(params.row);
                        //     },
                        //     false,
                        //     "1.6vw"
                        // )
                    )
                }
            }
        }
    ];

    const handleOrderClick = (params) => {
        setSelectedOption("Order");
        routeToPatientDetails(params);
    };
    const routeToPatientDetails = (params) => {
        if (params) {
            const { primary_payment } = params.row;
            const patientDetails = {
                ...params.row,
                insurance_name: primary_payment?.insurance_detail?.patient_insurance_company || "",
                company_name: primary_payment?.corporate_detail?.company_name || "",
                policy_number: primary_payment?.insurance_detail?.policy_number || "",
                employee_id: primary_payment?.corporate_detail?.id_no || "",
                module_type: "Walkin",
            }
            setCachevalue(JSON.stringify(patientDetails), "IppatientData");
        }

        switch (selectedOption) {
            case "createPatient":
                history.push({ pathname: "/WalkinAdmission/CreateAppointment" })
                break;
            case "ReceivePayment":
                history.push({ pathname: "/WalkinAdmission/PatientDetails/ReceivePayment" })
                break;
            case "ServiceBilling":
                history.push({ pathname: "/Walkin/PatientDetails/ServiceBilling" })
                break;
            case "Order":
                history.push({ pathname: "/WalkinAdmission/PatientDetails/CreateOrder" })
                break;
            // case "BillDetails":
            //     this.getPatientBillDetailedPrint(params)
            //     break;
            // case "AdmissionCard":
            //     this.getAdmissionCard(params)
            //     break;
            // case "SummaryBill":
            //     this.getIpSummaryBillPrint(params)
            //     break;
            // case "ApproxBill":
            //     this.getApproxBillPrint(params)
            //     break;
            // case "CommonBarcode":
            //     this.getCommonBarCodePrint(params)
            //     break;
            // case 'ChangeTag':
            //     this.postChangeTagNormal(params)
            //     break;
            // case 'DischargeSlip':
            //     this.printDischargeSlip(params)
            //     break;
            // case 'DataSheet':
            //     this.IPPatientDataSheetPrint(params)
            //     break;
            // case 'AttenderCard':
            //     this.AttenderCardPrint(params)
            //     break;
            // case 'AdmissionHistory':
            //     this.AdmissionHistory(params)
            //     break;
            default:
                break;
        }
    }

    const routeToDemograhics = (params) => {
        if (params.row.status === "Cancelled") return;
        setCachevalue(JSON.stringify(params.row), "IppatientData");

        const allowedFields = [
            "patientDetails",
            "status",
            "bill_amount",
            "referred_doctor",
            "completed_appointment",
            "completed_days",
        ];
        if (allowedFields.includes(params.field)) {
            if(LoggedData?.module_name === "front_office") {
                history.push("/WalkInAdmission/PatientDetails/Demographics");
            } else {
                history.push("/WalkInAdmission/PatientDetails/TreatmentPlan");
            }
        }
    }

    return (
        <Box sx={{ height: "85vh", width: "100%", backgroundColor: Colors.Background, p: 1 }}>
            {/* Header area: date picker & cards */}
            <div className='' style={{ justifyContent: "end" }}>
                {/* <Typography class="">Counsellor</Typography> */}
                <div className='eMed_Header_OP_home_div' style={{ justifyContent: "end", alignItems: "center", display: "flex", gap: 8 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            value={filterDate ? filterDate : null}
                            name={"datePicker"}
                            inputFormat='DD-MM-YYYY'
                            views={["year", "month", "day"]}
                            onChange={(newDate) => {
                                setFilterDate(newDate);
                            }}
                            renderInput={(params) => <TextField
                                {...params}
                                label={"Date"}
                                variant="outlined"
                                onKeyDown={(e) => e.preventDefault()}
                                sx={{ width: '15dvw', marginLeft: '1vw' }}
                                size='small'
                            />}
                        />
                    </LocalizationProvider>
                    <Tooltip title="Print" placement="top" arrow>
                        <span>
                            <IconButton
                                size="small"
                                onClick={handleTablePrint}
                                disabled={!appointments?.length || printLoading}
                            >
                                <PrintIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                </div>
            </div>
            <Box display="flex" justifyContent="end" alignItems="center">
                <Box display="flex" gap={1}>
                    <AppointmentCard
                        onClick={() => onCardClick("")}
                        count={statusCount?.total_count || 0}
                        label={"All"}
                        color={"#04B7B1"}
                        isSelectedCard={selectedStatus === "" || selectedStatus === null}
                    />
                    <AppointmentCard
                        onClick={() => onCardClick("Inprogress")}
                        count={statusCount?.total_inprogress_count || 0}
                        label={"Inprogress"}
                        color={"#616161"}
                        isSelectedCard={selectedStatus === "Inprogress"}
                    />
                    <AppointmentCard
                        onClick={() => onCardClick("Completed")}
                        count={statusCount?.total_completed_count || 0}
                        label={"Completed"}
                        color={"#0461B7"}
                        isSelectedCard={selectedStatus === "Completed"}
                    />
                    <AppointmentCard
                        onClick={() => onCardClick("Cancelled")}
                        count={statusCount?.total_cancelled_count || 0}
                        label={"Cancelled"}
                        color={"#B8170D"}
                        isSelectedCard={selectedStatus === "Cancelled"}
                    />
                </Box>
            </Box>

            {/* Data Grid area */}
            <Box sx={{ height: '62vh', backgroundColor: 'white' }}>
                <DataGrid
                    rows={appointments || []}
                    columns={columns}
                    getRowId={(row) => row.id}
                    pageSizeOptions={pageSizeOptions}
                    pagination
                    paginationMode="client"
                    paginationModel={{
                        page: page,
                        pageSize: pageSize
                    }}
                    onPaginationModelChange={(model) => {
                        setPage(model.page)
                        setPageSize(model.pageSize)
                    }}
                    onCellClick={(params) => {
                        if (params.row.status !== "Cancelled") {
                            routeToDemograhics(params);
                        }
                    }}
                    density="comfortable"
                    headerHeight={40}
                    rowHeight={45}
                    disableRowSelectionOnClick
                    sx={{
                        '& .MuiDataGrid-columnHeaders': {
                            minHeight: 35,
                            maxHeight: 35,
                        },
                    }}
                    components={{

                        NoRowsOverlay: () => (
                            <Box sx={{ display: "flex", height: "100%", alignItems: "center", justifyContent: "center" }}>
                                No Records To Be Shown
                            </Box>
                        ),
                    }}
                />
            </Box>
            <CollectAdvanceModal
                open={menuRow && openAdvance}
                onClose={() => { setOpenAdvance(false); setMenuRow(); }}
                onCollect={(data) => advanceCollect(data)}
                patientData={menuRow}
                errorMessage={(msg) => { errorMessage(msg) }}
            />
            <Dialog open={finalBillDialogOpen} onClose={() => { if (!finalBillApiLoading) { setFinalBillDialogOpen(false); setFinalBillDialogRow(null); } }}>
                <DialogTitle>Initiate Final Bill</DialogTitle>
                <DialogContent>
                    <Typography>Are you sure you want to initiate the final bill? You can then proceed to generate the final bill and checkout.</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setFinalBillDialogOpen(false); setFinalBillDialogRow(null); }} disabled={finalBillApiLoading}>Cancel</Button>
                    <Button variant="contained" onClick={onInitiateFinalBillConfirm} disabled={finalBillApiLoading}>Initiate</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={checkoutDialogOpen} onClose={() => { if (!finalBillApiLoading) { setCheckoutDialogOpen(false); setCheckoutDialogRow(null); } }}>
                <DialogTitle>Checkout</DialogTitle>
                <DialogContent>
                    <Typography>Are you sure you want to checkout this patient?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setCheckoutDialogOpen(false); setCheckoutDialogRow(null); }} disabled={finalBillApiLoading}>Cancel</Button>
                    <Button variant="contained" color="primary" sx={{ bgcolor: "#2e7d32", "&:hover": { bgcolor: "#1b5e20" } }} onClick={onCheckoutConfirm} disabled={finalBillApiLoading}>Checkout</Button>
                </DialogActions>
            </Dialog>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {(isLoading || printLoading || finalBillApiLoading) && <Loader />}
        </Box>
    );
};

export default WalkInAdmission;